<template>
  <div class="order-list-page">
    <search-filter-new
      :campus="params.campusList"
      :items="searchItems"
      placeholder="请输入学员姓名"
      @onExport="output"
      @onCampus="chooseCampus"
      @onSearch="params.searchName = $event"
    />
    <search-filter-new @change="filterChange">
      <date-range-filter
        class="justify-left"
        :start="filterParams.startTime | formatDatetime('yyyy-MM-dd')"
        :end="filterParams.endTime | formatDatetime('yyyy-MM-dd')"
        @clickDate="chooseCalendar"
      />
      <FilterItem 
        :hasFilter="!!filterParams.productTypeList.length" 
        keyName="productTypeList"
        :value="filterParams.productTypeList"
        kind="yq-通用选择" 
        title="结转项目"
        
        :list="
        [
          { text: '课程', value: 2 },
          { text: '班级', value: 1 },
          { text: '课时包', value: 4 },
          { text: '物品', value: 0 },
        ]" 
        class="justify-right" />
    </search-filter-new>
    <order-list-tab  ref='orderList'  class="orderList" :params="params" :filterParams="filterParams" :orderType="3"></order-list-tab>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import dateRangeFilter from '@x3/vue/filter-comps/date-range-filter.vue';
import FilterItem from '@x3/vue/comp/filter-item.vue';
import orderListTab from './child/order-list-tab.vue';
import emptyPage from '@teacher/components/empty-page.vue';
import { openOrderFiltrate } from './filtrate/index.js';

export default {
  name: 'order-list',
  components: {
    SearchFilterNew,
    dateRangeFilter,
    FilterItem,
    orderListTab,
    emptyPage,
  },
  data() {
    return {
      pageTitle: '结转记录',
      filterParams: {        
        startTime: app.tool.date.getBasedOnToDayDate(-30),
        endTime: new Date(),
        productTypeList: [],
      },
      params: {
        searchName: '',
        // 校区ID集合
        campusIds: [app.teacher.campusId],
        campusList: [app.teacher.campus],
      },
    };
  },
  computed: {
    searchItems () {
      let arr = ['campus','search'];
      if (app.permission.op('export_refund')) {
        arr.push('export')
      }
      return arr;
    },
    hasFilter: function () {
      let fParams = this.filterParams;
      if (
        fParams.startTime ||
        fParams.endTime ||
        (fParams.teacherList && fParams.teacherList.length > 0) ||
        (fParams.sourceTypeList && fParams.sourceTypeList.length > 0) ||
        (fParams.productTypeList && fParams.productTypeList.length > 0) ||
        (fParams.orderStatusList && fParams.orderStatusList.length > 0) ||
        (fParams.oweFeeList && fParams.oweFeeList.length > 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 导出
    async output() {
      if (this.$refs.orderList.list.length == 0) {
        return vant.Toast.fail('没有可导出的数据');
      }
      await this.$api.doReport15({
        campusIds: this.params.campusIds,
        condition: this.$refs.orderList.apiParams,
      });

      vant.Dialog.alert({
        title: '已导出任务',
        message: `已创建导出任务，请登录云校电脑端（yunxiao.xiaogj.com）点击右上角“任务中心”下载导出文件。`,
        confirmButtonText: '确认',
      });
    },
    // 选择时间
    chooseCalendar() {
      app.x3.picker.dateRange({
        startDate: this.filterParams.startTime,
        endDate: this.filterParams.endTime,
      })
      .then(res => {
        console.log(res)
        this.filterParams.startTime = res.startDate;
        this.filterParams.endTime = res.endDate;
      })
      .catch(()=>{
        console.log('取消选择或报错了')
      })
    },
    // 打开筛选
    async openFilter() {
      let res = await openOrderFiltrate({
        config: {
          orderType: 3,
          campusIds: this.params.campusIds,
        },
        params: this.filterParams,
      });
      this.filterParams = {
        ...res.params,
      };
    },
    filterChange (res) {
      Object.assign(this.filterParams, res);
    }
  },
};
</script>

<style lang="scss" scoped>
.order-list-page {
  display: flex;
  flex-direction: column;
  .search-filter{
    position: relative;
    z-index: 12;
  }
  .order-tabs {
    margin-top: 1px;
    flex: 1;
    display: flex;
    flex-direction: column;
    ::v-deep .van-tabs__content {
      flex: 1;
      .tab-list {
        height: 100%;
      }
    }
  }
  .orderList{
    position: relative;
    z-index: 1;
  }
}
</style>